import { SITE_PAGES } from "../data/site";

export interface BreadcrumbCrumb {
  label: string;
  path: string;
}

const HOME_CRUMB: BreadcrumbCrumb = { label: "Home", path: "/" };

/**
 * Derives the breadcrumb trail from SITE_PAGES (the same single source of
 * truth already used by the 404 page and global search) rather than
 * maintaining a second, parallel route→label map that could drift.
 * `dynamicLabel` covers the one nested route this app has today
 * (/success-stories/case-studies/:slug), whose final segment is real
 * content (a case study title) that isn't a static SITE_PAGES entry.
 */
export function getBreadcrumbTrail(pathname: string, dynamicLabel?: string): BreadcrumbCrumb[] {
  if (pathname === "/") return [HOME_CRUMB];

  const trail: BreadcrumbCrumb[] = [HOME_CRUMB];

  if (pathname.startsWith("/success-stories/case-studies/")) {
    trail.push({ label: "Success Stories", path: "/success-stories" });
    trail.push({ label: dynamicLabel ?? "Case Study", path: pathname });
    return trail;
  }

  // Edit profile: Home > Profile > Edit profile.
  if (pathname === "/profile/edit") {
    trail.push({ label: "Profile", path: "/profile" });
    trail.push({ label: "Edit profile", path: pathname });
    return trail;
  }

  // One order: Home > My Orders > <order reference>.
  if (pathname.startsWith("/orders/")) {
    trail.push({ label: "My Orders", path: "/orders" });
    trail.push({ label: dynamicLabel ?? "Order", path: pathname });
    return trail;
  }

  // A single catch: Home > The Catch > <name> (the name is content, so the page passes it in).
  if (pathname.startsWith("/menu/")) {
    trail.push({ label: "The Catch", path: "/menu" });
    trail.push({ label: dynamicLabel ?? "Catch", path: pathname });
    return trail;
  }

  const page = SITE_PAGES.find((p) => p.path === pathname);
  if (page) {
    trail.push({ label: page.title, path: pathname });
  }

  return trail;
}
